"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KiloWattPerCubicFootPerMinute = exports.WattPerCubicMeterPerSecond = exports.KiloWattPerCubicMeterPerSecond = void 0;
var uom_1 = require("uom");
exports.KiloWattPerCubicMeterPerSecond = uom_1.UnitFormat.createUnitFormat("kW/m³/s", 2);
exports.WattPerCubicMeterPerSecond = uom_1.UnitFormat.createUnitFormat("W/m³/s", 0);
exports.KiloWattPerCubicFootPerMinute = uom_1.UnitFormat.createUnitFormat("kW/ft³/min", 2);
//# sourceMappingURL=specific-fan-power-format.js.map